module.exports = __webpack_public_path__ + "static/media/JasonBourne.99ed456d.jpg";